import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite';
import './index.scss';
import shareNamecard from '@assets/img/share-namecard.svg';
import { scroller } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { MGMShares } from '@interfaces/portal';
import { useShareReplace } from '@commons/shareLink';
interface NamecardProps {
    mgmShares: MGMShares,
    mgmCode: string,
    setShowNameCard: (status: boolean) => void;
}
const NamecardShare:React.FC<NamecardProps> = observer((props)=> {
    const {i18n} = useTranslation();
    const language = i18n.language;
    const {setShowNameCard} = props;
    const { formatString } = useShareReplace()
    const [shareUrl, setShareUrl] = useState(`${REACT_APP_ReferralShortURL}/w/${props.mgmCode}/${language === 'zh-HK' ? 'tc' : 'en'}`);
    

    const getShareMessageData = () => {
        let msg = formatString(props.mgmShares.nameCardRedirect || '', [props.mgmCode,`${language === 'zh-HK' ? 'tc' : 'en'}`])
        return msg;
    }

    const handleShareClick = () => {
        if (props.mgmCode) {
            setShowNameCard(true)
        } else {
            scroller.scrollTo("account", {
                smooth: 'easeOutQuad',
                duration: 800,
            })
        }
    }

    return (
        <div className='sharemsg-icon' onClick={handleShareClick}>
            <img src={shareNamecard} alt="" />
        </div>
    )
})

export default NamecardShare;